import React from 'react';

export const ConfirmIcon: React.FC<sharedComponents.SvgIcon> = ({ height = 22, width = 22, className = '' }) => (
  <svg
    width={`${width}px`}
    height={`${height}px`}
    viewBox="0 0 22 22"
    className={className}
  >
    <title>Confirm icon</title>
    <desc>Confirm icon</desc>
    <path
      d="M11 0c6.075 0 11 4.925 11 11s-4.925 11-11 11S0 17.075 0 11 4.925 0 11 0Zm0 2a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm4.294 4.292 1.412 1.416-7.75 7.728-3.685-3.923 1.458-1.37 2.274 2.421 6.29-6.272Z" // eslint-disable-line
      fillRule="evenodd"
    />
  </svg>
);
